module.exports = new __parcel__URL__("ww-title-on-air-navigation.09e178ca.jpg").toString();